<script lang="ts">
  import { Button } from '$lib/components/ui/button'
  import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '$lib/components/ui/card'
  import notifications from '$lib/stores/notifications'
  import type { UserNotification } from '@coso/core/realtime/types'
  import Icon from '@iconify/svelte'

  const alertIcons: Record<UserNotification['level'], { icon: string; color: string }> = {
    success: { icon: 'mdi:check-circle-outline', color: 'text-green-500' },
    error: { icon: 'mdi:report-problem', color: 'text-red-500' },
    info: { icon: 'mdi:information-outline', color: 'text-blue-500' },
    warning: { icon: 'mdi:warning-circle-outline', color: 'text-yellow-500' },
  }

  let popups = $derived(Object.entries($notifications).filter((a) => a[1].type == 'popup'))
</script>

{#if popups.length > 0}
  <div class="fixed inset-0 z-50 bg-black/50">
    {#each popups as [key, popup], i}
      <Card
        class="fixed mx-4 w-full max-w-md -translate-x-1/2 -translate-y-1/2"
        style="top: calc(50% + {i * 8}px); left: calc(50% + {i * 8}px); z-index: {50 + i};"
      >
        <CardHeader>
          <CardTitle class="flex items-center gap-2 text-lg">
            <Icon icon={alertIcons[popup.level].icon} class={alertIcons[popup.level].color} />
            {popup.title}
          </CardTitle>
        </CardHeader>

        <CardContent class="space-y-4">
          {#if popup.images}
            <div class="space-y-2">
              {#each popup.images as image, i}
                <div class="relative">
                  <img src={image} alt="Alert" class="w-full rounded-md object-cover" />
                  <span class="absolute top-2 left-2 rounded bg-black/50 px-2 py-1 text-xs text-white">
                    {i + 1}/{popup.images.length}
                  </span>
                </div>
              {/each}
            </div>
          {/if}

          <p class="text-muted-foreground text-sm whitespace-pre-line">
            {popup.message}
          </p>
        </CardContent>

        <CardFooter class="flex justify-end">
          <Button variant="secondary" onclick={() => notifications.remove(key)}>OK</Button>
        </CardFooter>
      </Card>
    {/each}
  </div>
{/if}
